export default {
  LIST(state, data) {
    state.letters = data
  },
  TABLE_ONE(state, data) {
    state.table_one = data
  },
  TABLE_TWO(state, data) {
    state.table_two = data
  },
  GET(state, data) {
    state.letter = data
  },
  HISTORY_LETTER(state, data) {
    state.history_letter = data
  },
  PERIODS(state, data) {
    state.periods = data
  },
  ORGANIZATIONS(state, data) {
    state.organizations = data
  },
  UPDATE(state, value) {
    state.letter = {
      ...value,
      from_org: value.from_org.id,
      to_org: value.to_org.id,
      period: value.period.id,
      letter_file: null,

    }
  },
  FRESH(state, letter_type = null) {
    state.letter = {
      id: null,
      code: '',
      short_info: '',
      letter_status: 100,
      letter_type,
      period: null,
      from_org: null,
      to_org: null,
    }
  },
  FRESH_HISTORY(state, letter_type = null) {
    state.history_letter = {
      id: null,
      code: '',
      short_info: '',
      letter_status: 100,
      letter_type,
      period: null,
      from_org: null,
      to_org: null,
    }
  },
}
